"use strict";

module.exports = [
  "clients",
  "clientsAll",
  "members",
  "$translate",
  "dialog",
  "Member",
  "$state",
  "Authentication",
  "$uibModal",
  "toast",
  "myTenant",
  "gridConfiguration",
  "$scope",
  "$compile",
  "$timeout",
  function (
    clients,
    clientsAll,
    members,
    $translate,
    dialog,
    Member,
    $state,
    Authentication,
    $uibModal,
    toast,
    myTenant,
    gridConfiguration,
    $scope,
    $compile,
    $timeout
  ) {
    var _this = this;
    this.members = members;
    _this.clients = clients;
    _this.clientsAll = clientsAll;
    this.tenantId = myTenant.get().id;

    this.userId = window.localStorage.$LoopBack$currentUserId;
    this.Authentication = Authentication;
    _this.showHelp = false;
    _this.selectedItems = [];
    this.selectAllStatus = false;

    this.loadingCompanies = true;
    this.hasActiveFilters = false;

    this.hasAppliedGridFilters = function () {
      if (
        !_this.gridOptions ||
        !_this.gridOptions.api ||
        !_this.gridOptions.api.getFilterModel
      ) {
        return false;
      }
      const fm = _this.gridOptions.api.getFilterModel();
      if (!fm || typeof fm !== "object") return false;
      return Object.keys(fm).some(function (key) {
        const entry = fm[key];
        if (entry == null) return false;
        if (Array.isArray(entry)) return entry.length > 0;
        if (typeof entry === "object" && entry.filter !== undefined) {
          return (
            entry.filter !== null &&
            entry.filter !== undefined &&
            entry.filter !== ""
          );
        }
        return true;
      });
    };

    this.updateActiveFiltersState = function () {
      _this.hasActiveFilters = _this.hasAppliedGridFilters();
    };

    this.resetFilters = function () {
      if (_this.gridOptions && _this.gridOptions.api) {
        _this.gridOptions.api.setFilterModel(null);
        $timeout(function () {
          _this.updateActiveFiltersState();
        }, 0);
      }
    };

    this.refreshGridRowData = function (rowData, options) {
      if (!_this.gridOptions || !_this.gridOptions.api) return;
      options = options || {};
      const api = _this.gridOptions.api;
      let filterModel = null;
      if (api.getFilterModel) {
        const currentFilter = api.getFilterModel();
        if (currentFilter && Object.keys(currentFilter).length > 0) {
          filterModel = JSON.parse(JSON.stringify(currentFilter));
        }
      }
      api.setRowData(rowData);
      if (filterModel && api.setFilterModel) {
        api.setFilterModel(filterModel);
      }
      $timeout(function () {
        let visibleCount = 0;
        api.forEachNodeAfterFilterAndSort(function () {
          visibleCount++;
        });

        if (options.clearFiltersIfEmpty && visibleCount === 0) {
          api.setFilterModel(null);
        } else if (filterModel && !_this.hasAppliedGridFilters()) {
          api.setFilterModel(null);
        }

        _this.updateActiveFiltersState();
      }, 0);
    };

    this.viewAssigments = function () {
      $uibModal.open({
        animation: true,
        controller: require("./dashboardUsersAssigmentsCtrl"),
        templateUrl: "dashboard-users/dashboardUsersAssigments.html",
        controllerAs: "ctrl",
        size: "allwidth",
        windowClass: "dialog",
        bindToController: true,
        resolve: { members: () => _this.members },
      });
    };

    this.viewUserStatistics = function (tenantId) {
        var options = {
            animation: true,
            controller: require("./detailStatistics"),
            templateUrl: 'dashboard-users/detailStatistics.html',
            controllerAs: 'ctrl',
            size: 'xlg',
            windowClass: 'dialog',
            bindToController: true,
            resolve: {
              tenantId: function () {
                    return tenantId
                }
            }
        };
        $uibModal.open(options);
    };

    this.inviteUsers = function () {
      if( !_this.Authentication.isAuthorized(["admin"]) && myTenant.get().id =="5b5f4e06c5b6835e37da0d7e"){
        alert("Por orden de la Dirección de Tecnologías de la Información, únicamente los administradores tienen la capacidad de crear nuevos usuarios. Cualquier solicitud ponerse en contacto con un administrador de sistema");
        return;
      }
      $uibModal
        .open({
          animation: true,
          controller: require("./dashboardInviteUsersModal"),
          templateUrl: "dashboard-users/dashboardInviteUsersModal.html",
          controllerAs: "modal",
          size: "md",
          windowClass: "dialog",
          bindToController: true,
        })
        .result.then(function (new_members) {
          _this.members = _this.members.concat(new_members);
        });
    };

    _this.downloadCSV = function () {
      _this.gridOptions.api.exportDataAsCsv({
        fileName: "UsersList.csv",
      });
    };

    _this.downloadXLSX = function () {
      if (_this.gridOptions.api) {
        window.exportarAgGridAExcel(_this.gridOptions.api, "UsersList.xlsx");
      }
    };

    _this.updAD = function () {
      let userAD = _this.members.filter((m) => m.fromAzureAD == true);

      userAD.forEach((u) => {
        let dataAD = JSON.parse(u.AzureADJson);
        if (
          dataAD[
            "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User"
          ] &&
          dataAD["urn:ietf:params:scim:schemas:extension:enterprise:2.0:User"]
            .department
        )
          u.dept =
            dataAD[
              "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User"
            ].department;
        if (
          dataAD[
            "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User"
          ] &&
          dataAD["urn:ietf:params:scim:schemas:extension:enterprise:2.0:User"]
            .employeeNumber
        )
          u.employeeNumber =
            dataAD[
              "urn:ietf:params:scim:schemas:extension:enterprise:2.0:User"
            ].employeeNumber;
        if (dataAD.title) u.title = dataAD.title;
        if (dataAD.addresses && dataAD.addresses[0].region)
          u.region = dataAD.addresses[0].region;
        if (dataAD.addresses && dataAD.addresses[0].formatted)
          u.office = dataAD.addresses[0].formatted;
        Member.upsert(u);
      });
    };

    this.editUser = function (memberSelected) {
      if( memberSelected==undefined && !_this.Authentication.isAuthorized(["admin"]) && myTenant.get().id =="5b5f4e06c5b6835e37da0d7e"){
        alert("Por orden de la Dirección de Tecnologías de la Información, únicamente los administradores tienen la capacidad de crear nuevos usuarios. Cualquier solicitud ponerse en contacto con un administrador de sistema");
        return;
      }
      $uibModal
        .open({
          animation: true,
          controller: require("./dashboardAddUserModal"),
          templateUrl: "dashboard-users/dashboardAddUserModal.html",
          controllerAs: "modal",
          size: "allwidth",
          windowClass: "dialog",
          bindToController: true,
          resolve: {
            memberSelected: () => memberSelected,
            clients: () => _this.clients,
            clientsAll: () => _this.clientsAll,
            members: () => _this.members
          },
        })
        .result.then(function (memberReturned) {
          if (memberSelected != undefined) {
            let memberIdx = _this.members.findIndex(
              (m) => m.id == memberSelected.id
            );
            _this.members[memberIdx] = memberReturned;
            _this.refreshGridRowData(_this.members);
          } else {
            _this.members.push(memberReturned);
            _this.members.sort((a, b) =>
              (a.lastName || "").localeCompare(b.lastName || "")
            );
            _this.refreshGridRowData(_this.members);
          }
        });
    };

    this.selectAll = function (status) {
      if (status) {
        _this.gridOptions.api.forEachNodeAfterFilterAndSort(function (node) {
          _this.gridOptions.api.selectNode(node, true);
        });
        return;
      }
      _this.gridOptions.api.deselectAll();

      return;
    };
    let debounceTimer;
    const debounce = (func, delay) => {
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
      };
    };

    this.removeUser = function (memberId) {
      debounce(() => {
        let membersToDelete;

        if (memberId) {
          const member = _this.members.find((m) => m.id == memberId);
          if (!member) return;
          membersToDelete = [member];
        } else {
          if (_this.selectedItems.length == 0) {
            toast.error("Debes seleccionar al menos un usuario");
            return;
          }
          membersToDelete = _this.selectedItems.slice();
        }

        const idsToDelete = membersToDelete.map((member) => member.id);
        const usersList = membersToDelete.map((member) => member.email);

        dialog
          .confirm({
            title: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_REMOVE_USER.TITLE"
            ),
            body: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_REMOVE_USER.BODY",
              { usersEmail: usersList.join(", ") }
            ),
            accept: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_REMOVE_USER.ACCEPT"
            ),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: "md",
          })
          .then(function () {
            idsToDelete.forEach((id) => {
              Member.delete({ memberId: id }, {})
                .$promise.then(function () {
                  _this.members = _this.members.filter(
                    (member) => member.id !== id
                  );
                  _this.selectedItems = _this.selectedItems.filter(
                    (member) => member.id !== id
                  );
                  _this.refreshGridRowData(_this.members, { clearFiltersIfEmpty: true });
                })
                .catch(function (error) {
                  console.log(error);
                });
            });
            _this.gridOptions.api.deselectAll();
          })
          .catch(function (error) {
            console.log(error);
          });
        return false;
      }, 200)();
    };
    this.NotificationWrite = function (memberId) {
      debounce(() => {
        if (_this.selectedItems.length == 0) {
          toast.error("Debes seleccionar al menos un usuario");
          return;
        }
        $uibModal
          .open({
            animation: true,
            controller: [
              "$uibModalInstance",
              "Member",
              "checkUser",
              function ($uibModalInstance, Member, checkUser) {
                var _this = this;
                _this.checkUser = checkUser;
                this.title = "";
                this.body = "";
                this.sendMessage = function () {
                  let lstIds = [];
                  _this.checkUser.forEach(function (user) {
                    lstIds.push(user.id);
                  });
                  Member.pushNotification({
                    title: _this.title,
                    body: _this.body,
                    memberId: lstIds,
                  });
                  _this.$dismiss();
                };
              },
            ],
            templateUrl: "dashboard-users/dashboardNotificationModal.html",
            controllerAs: "modal",
            size: "md",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
              checkUser: function () {
                return _this.selectedItems;
              },
            },
          })
          .result.then(function () {});
      }, 200)();
    };

    this.unmakeAdmin = function (userId) {
      debounce(() => {
        dialog
          .confirm({
            title: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_UNMAKEADMIN.TITLE"
            ),
            body: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_UNMAKEADMIN.BODY"
            ),
            accept: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_UNMAKEADMIN.ACCEPT"
            ),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: "sm",
          })
          .then(function () {
            return Member.unmakeadmin({
              userId: userId,
            })
              .$promise.then(function () {
                if (userId === window.localStorage.$LoopBack$currentUserId) {
                  Authentication.logOut().then(function () {
                    return $state.go("login");
                  });
                } else {
                  _this.members.find((m) => m.id == userId).roles = [];
                  _this.refreshGridRowData(_this.members);

                  //$state.reload("dashboard");
                }
              })
              .catch(function (error) {});
          });
      }, 200)();
    };

    this.makeAdmin = function (userId) {
      debounce(() => {
        dialog
          .confirm({
            title: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_MAKEADMIN.TITLE"
            ),
            body: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_MAKEADMIN.BODY"
            ),
            accept: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_MAKEADMIN.ACCEPT"
            ),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: "sm",
          })
          .then(function () {
            return Member.makeadmin({
              userId: userId,
            })
              .$promise.then(function () {
                //$state.reload("dashboard");
                _this.members
                  .find((m) => m.id == userId)
                  .roles.push({ name: "admin" });
                _this.refreshGridRowData(_this.members);
              })
              .catch(function (error) {
                console.log(error);
              });
          });
      }, 200)();
    };

    this.releaseDevice = function (userId) {
      debounce(() => {
        const user = _this.members.find((m) => m.id == userId);
        dialog
          .confirm({
            title: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_REL_DEV.TITLE"
            ),
            body: $translate.instant("DASHBOARD.DASH_USERS.DIAG_REL_DEV.BODY", {
              userName: user.firstName + " " + user.lastName,
            }),
            accept: $translate.instant(
              "DASHBOARD.DASH_USERS.DIAG_REL_DEV.ACCEPT"
            ),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: "sm",
          })
          .then(function () {
            // Eliminar todos los dispositivos asignados al usuario
            return Member.device.destroyAll({
                id: user.id
              })
              .$promise.then(function () {
                $state.reload("dashboard");
              })
              .catch(function (error) {
                console.log(error);
              });
          });
      }, 200)();
    };

    _this.columnDefs = [
      {
        headerCellRenderer: function (params) {
          var toReturn =
            '<span ng-click="ctrl.selectAll(ctrl.selectAllStatus)" class="select-header-span" style="height: 20px;margin-top: -10px;"><input type="checkbox" ng-model="ctrl.selectAllStatus" class="ag-selection-checkbox select-header-checkbox"></span>';
          var eDiv = document.createElement("div");
          eDiv.innerHTML = toReturn;
          $compile(eDiv)($scope);
          return eDiv;
        },
        field: "",
        checkboxSelection: true,
        width: 50,
        suppressMenu: true,
        suppressSorting: true,
        pinned: "left",
        suppressResize: true,
      },
      {
        headerName: "AdminGral",
        field: "id",
        hide: !_this.Authentication.isAuthorized(["admin"]),
        checkboxSelection: false,
        width: 70,
        suppressMenu: true,
        suppressSorting: true,
        suppressResize: true,
        type: "centerAligned",
        pinned: "left",
        cellRenderer: function (params) {
          var toReturn = [];
          if (params.data == undefined || params.data.id == undefined) return;
          var eDiv = document.createElement("div");
          let initialAdmin =
            params.data.roles &&
            params.data.roles.length === 1 &&
            params.data.roles[0].name === "admin";
          if (!initialAdmin && params.value != _this.userId) {
            if (
              params.data.roles &&
              params.data.roles.find(
                (rol) => rol.name == "admin" || rol.name == "fieldAdmin"
              )
            )
              toReturn.push(
                '<a href uib-tooltip="Quitar permiso de administrador general" tooltip-append-to-body="true" tooltip-placement="top" ng-click="ctrl.unmakeAdmin(\'' +
                  params.value +
                  '\')" ><i class="mdi mdi-toggle-switch" style="font-size: 28px; line-height: 1; color: olive; padding: 3px;"></i> </a>'
              );
            else
              toReturn.push(
                '<a href uib-tooltip="Convertir en administrador general" tooltip-append-to-body="true" tooltip-placement="top" ng-click="ctrl.makeAdmin(\'' +
                  params.value +
                  '\')" ><i class="mdi mdi-toggle-switch-off" style="font-size: 28px; line-height: 1; color: blue; padding: 3px;"></i> </a>'
              );
          } else
            toReturn.push(
              '<a href uib-tooltip="Propietario del tenant" tooltip-append-to-body="true" tooltip-placement="top"><i class="mdi mdi-toggle-switch" style="font-size: 28px; line-height: 1; color: #ccc; padding: 3px;"></i> </a>'
            );
          if (params.data.fromAzureAD)
            toReturn.push(
              '<i title="Usuario de Azure AD" class="icon ion-social-windows" style="color:lightblue;margin: 5px;background-color: white;padding: 2px;font-size: 20px;"></i>'
            );
          eDiv.innerHTML = toReturn.join("");
          $compile(eDiv)($scope);
          return eDiv;
        },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.ACTIVE"),
        field: "emailVerified",
        width: 70,
        colId: "isOU",
        cellRenderer: gridConfiguration.checkboxRenderer,
        filter: "set",
        filterParams: { values: [true, false] },
      },
      {
        headerName: "",
        field: "profileUrl",
        width: 45,
        cellRenderer: gridConfiguration.profileRender,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.NAME"),
        field: "firstName",
        width: 150,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.LASTNAME"),
        field: "lastName",
        width: 150,
        initialSortIndex: 1,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.EMAIL"),
        field: "email",
        width: 150,
        pinned: "left",
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.LAST_LOGON"),
        field: "lastLogon",
        valueGetter: function (params) {
          if(params.data.lastLogon)
            return new Date(params.data.lastLogon).getYYYYMMddHHmmss();
          return "";
        },
        hide: ![
          "5f159630815b7f852fbd1f6a",
          "56fc21e402a3885f336d8d3f","5b5f4e06c5b6835e37da0d7e"
        ].includes(myTenant.get().id),
        width: 150,
        filter: gridConfiguration.dateFilter,
        comparator : gridConfiguration.dateComparator
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.CREATED_AT"),
        field: "_createdAt",
        valueGetter: function (params) {
          if (params.data._createdAt)
            return new Date(params.data._createdAt).getYYYYMMddHHmmss();
          return "";
        },
        width: 150,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.CECO"),
        field: "ceco",
        width: 150,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.CLIENTS"),
        field: "clients",
        width: 150,
        valueGetter: function (params) {
          if (params.data.clients)
            return params.data.clients.map((clt) => clt.name);
          return "";
        },
        filterParams: { values: _this.clients.map((clt) => clt.name) },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.COMPANY"),
        field: "company",
        width: 150,
        initialSortIndex: 1,
        valueGetter: function (params) {
            if (params.data?.company?.name)
              return params.data.company.name;
            return "";
          },
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.REGION"),
        field: "region",
        width: 150,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.OFFICE"),
        field: "office",
        width: 150,
      },

      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.DEPARTMENT"),
        field: "dept",
        width: 150,
      },
      {
        headerName: $translate.instant("DASHBOARD.DASH_USERS.COLS.TITLE"),
        field: "title",
        width: 150,
      },
      {
        headerName: $translate.instant(
          "DASHBOARD.DASH_USERS.COLS.EMPLOYEENUMBER"
        ),
        field: "employeeNumber",
        width: 150,
      },
      {
        headerName: "SSO",
        field: "fromAzureAD",
        width: 150,
        valueGetter: function (params) {
          if(params.data.fromAzureAD==true)
              return "Azure";
          else
            return ""
        }
      },
      {
        headerName: "",
        field: "id",
        checkboxSelection: false,
        width: 90,
        suppressMenu: true,
        suppressSorting: true,
        pinned: "right",
        cellRenderer: function (params) {
          if (params.data == undefined || params.data.id == undefined) return;
          var toReturn = [];
          var eDiv = document.createElement("div");
          eDiv.style.cssText = "text-align:right";
          let initialAdmin =
            params.data.roles &&
            params.data.roles.length === 1 &&
            params.data.roles[0].name === "admin";
          let hasDevice = params.data.device && params.data.device.length > 0;
          let canDelete = params.value != _this.userId && !initialAdmin;

          if (hasDevice) {
            toReturn.push(
              "<a href title='Enviar notificacion a dispositivos' ng-click=\"ctrl.NotificationWrite('" +
                params.value +
                '\')"><i class="icon ion-paper-airplane" style="font-size: 24px;color: tomato;padding: 3px;"></i> </a>'
            );
            toReturn.push(
              '<a href title="Desconectar Dispositivos: ' +
                params.data.device.map((d) => d.model).join(", ") +
                '"  ng-click="ctrl.releaseDevice(\'' +
                params.value +
                '\')" class="teams--delete"><i class="icon ion-power  danger" style="font-size: 24px;padding: 3px;"></i></a>'
            );
          } else {
            toReturn.push(
              '<a href title="No tiene conectado ningun dispositivo" ><i class="icon ion-paper-airplane" style="font-size: 24px;color: #ccc;padding: 3px;"></i> </a>'
            );
            toReturn.push(
              '<a href title="No tiene conectado ningun dispositivo"><i class="icon ion-power  danger" style="font-size: 24px;color: #ccc;padding: 3px;"></i></a>'
            );
          }
          if (canDelete && params.data.fromAzureAD!=true)
            toReturn.push(
              "<a href ng-click=\"ctrl.removeUser('" +
                params.value +
                '\')" class="teams--delete"><i class="icon ion-android-delete" style="font-size: 24px;padding: 3px;"></i></a>'
            );
          else
            toReturn.push(
              '<a href class="teams--delete"><i class="icon ion-android-delete"  style="color:#ccc;font-size: 24px;padding: 3px;"></i></a>'
            );

          eDiv.innerHTML = toReturn.join("");
          $compile(eDiv)($scope);
          return eDiv;
        },
      },
    ];

    _this.gridOptions = {
      rowData: _this.members,
      rowHeight: 35,
      rowSelection: "multiple",
      columnDefs: _this.columnDefs,
      pagination: false,
      enableFilter: true,
      enableSorting: true,
      enableColResize: true,
      angularCompileRows: true,
      angularCompileFilters: true,
      angularCompileHeaders: true,
      headerHeight: 40,
      localeText: gridConfiguration.localeText,
      onGridReady: function () {
        _this.gridOptions.api.addGlobalListener(function (type, event) {});
        var host = document.getElementById("dashboard-users-grid-host");
        if (host) {
          gridConfiguration.bindShiftWheelHorizontalScroll(host);
          gridConfiguration.bindPinnedRightScrollbarSync(host, _this.gridOptions.api);
        }
        _this.updateActiveFiltersState();
      },
      onAfterFilterChanged: function () {
        $timeout(function () {
          _this.updateActiveFiltersState();
        }, 0);
      },
      onSelectionChanged: function (selection) {
        _this.selectedItems = selection.selectedRows;
      },
      onRowDoubleClicked: function (row) {
        _this.editUser(row.data);
      },
    };

    // MODAL COMPANIES CREATE/EDIT
    this.companiesModal = function() {
        $uibModal.open({
            animation: true,
            templateUrl: 'dashboard-users/dashboardAddCompanyModal.html',
            controller: [
                "$uibModalInstance",
                "Company",
                "loadingCompanies",
                "savingData",
                function ($uibModalInstance, Company, loadingCompanies, savingData ) {
                    var _this = this;
                    _this.loadingCompanies = loadingCompanies;
                    _this.savingData = savingData;
                    
                    this.companyList = [];

                    this.getCompanies = function () {
                        _this.companyList = [];
                        _this.loadingCompanies = true

                        Company.find().$promise.then((data) => {
                            this.companyList = data?.sort(function(a, b) {
                                return a.name.localeCompare(b.name);
                                
                            });;
                            _this.loadingCompanies = false;
                        })
                        .catch(function (error) {
                            console.error(error);
                            _this.loadingCompanies = false;
                        });
                    }

                    this.customFilter = (company) => {
                        if (!_this.quickFilter) return true;
                        let query = _this.quickFilter.toLowerCase();
                        return (company.name && company.name.toLowerCase().includes(query)) ||
                            (company.externalId && company.externalId.toLowerCase().includes(query));
                    };

                    this.close = function () {
                        $uibModalInstance.close();
                    };

                    this.addEditCompany = function(type, company) {
                        $uibModal.open({
                            animation: true,
                            templateUrl: 'dashboard-users/dashboardNewCompanyModal.html',
                            controller: [
                                "$uibModalInstance",
                                "toast",
                                "$translate",
                                function ($uibModalInstance, toast, $translate) {
                                    var _this = this;
                                    this.type = type;
                                    this.companyName = company?.name || '';
                                    this.companyId = company?.id || '';
                                    this.companyCode = company?.externalId || '';
                
                                    this.accept = function () {
                                        if (_this.type == 'new') {
                                            Company.create({
                                                name: this.companyName,
                                                externalId: this.companyCode
                                            })
                                            .$promise.then(function (data) {
                                                $uibModalInstance.close(_this.type)
                                            })
                                            .catch(function (error) {
                                                toast.error($translate.instant('DASHBOARD.DASH_USERS.COMPANY.ERROR_COMPANY_NEW'));
                                                console.log(error);
                                            });
                                        } else if (_this.type == 'edit') {
                                            Company.prototype$updateAttributes({
                                                id: this.companyId,
                                            },
                                            {
                                                name: this.companyName,
                                                externalId: this.companyCode
                                            })
                                            .$promise.then(function (data) {
                                                $uibModalInstance.close(_this.type)
                                            })
                                            .catch(function (error) {
                                                toast.error($translate.instant('DASHBOARD.DASH_USERS.COMPANY.ERROR_COMPANY_MODIFY'));
                                                console.log(error);
                                            });
                                        }
                                    }
                                    
                                    this.close = function () {
                                        $uibModalInstance.close();
                                    };
                                },
                            ],
                            controllerAs: "modal",
                            size: "md",
                            windowClass: "dialog",
                            bindToController: true,
                        }).result.then((result) => {
                            if (result == 'new' || result == 'edit') {
                                _this.getCompanies();
                            }
                        }, function() {
                        });

                    }

                    this.deleteCompany = function (company) {
                        this.company = company;
                        dialog
                            .confirm({
                                title: $translate.instant("DASHBOARD.DASH_USERS.COMPANY.DIAG_DEL.TITLE"),
                                body: $translate.instant("DASHBOARD.DASH_USERS.COMPANY.DIAG_DEL.BODY"),
                                accept: $translate.instant("DASHBOARD.DELETE"),
                                cancel: $translate.instant("DASHBOARD.CANCEL"),
                                size: "sm",
                            })
                            .then(function () {
                                Company.delete({
                                    companyId: _this.company.id,
                                })
                                .$promise.then(function () {
                                    _this.getCompanies();
                                })
                                .catch(function (error) {
                                    toast.error($translate.instant('DASHBOARD.DASH_USERS.COMPANY.ERROR_COMPANY_DELETE'));
                                    console.log(error);
                                });
                            });
                    };
                    this.getCompanies();
                },
            ],
            controllerAs: "modal",
            size: "lg",
            windowClass: "dialog",
            bindToController: true,
            resolve: {
                loadingCompanies: () => _this.loadingCompanies,
                savingData: () => _this.savingData
            }
        }).result.then((result) => {
        }, function() {
        });
    };
  },
];
